<script>
  import FileUpload from "./FileUpload.svelte";
  import URLUpload from "./URLUpload.svelte";
 import DropboxUpload from "./DropboxUpload.svelte";

 
 /* import { onMount } from 'svelte';

    onMount(() => {
  *    console.log('picker component has mounted');
    });*/
  export let af;
  export let name;
  export let allAFs = [];
  let filename = "";
  let uploadActive = true;
  let urlActive = false;
  let dropboxActive = false;
  if (af.url){
      uploadActive = 0;
      urlActive = 1;
      dropboxActive = 0;
      if (af.url  && af.url.match("https://dl.dropboxusercontent.com/")){
          dropboxActive = 1;
          urlActive = 0;
          filename = af.url;
        }


  }
 
  let url;
  let title = "dummy";
  let notes;

// console.log(`Initial picker state ${uploadActive}  ${urlActive} ${dropboxActive} ${url}   name ${name} file ${filename} `,af );

 
  function handleUpload() {
    if (uploadActive) {
      uploadActive = 0;
      return;
    }
    uploadActive = 1;
    urlActive = 0;
    dropboxActive = 0;
  }

  function handleURL() {
    if (urlActive) {
      urlActive = 0;
      return;
    }

    uploadActive = 0;
    urlActive = 1;
    dropboxActive = 0;
  }
  function handleDropbox() {
    if (dropboxActive) {
      dropboxActive = 0;
      return;
    }

    uploadActive = 0;
    urlActive = 0;
    dropboxActive = 1;
  }

 
// $: console.log(`${uploadActive}  ${urlActive} ${dropboxActive} ${url} name ${name}  file ${filename}  `,af );


</script>

<style>
 .btn-success:not(:disabled):not(.disabled):active {
     background: #e78f2e;
 }
 .btn-active {
     background: #e78f2e;
 }
 .button-group {
     margin-bottom: 15px;
 }
 
 .picker .btn-active, .picker .btn-active:disabled,
 .picker .btn-active:hover,   .picker .btn-active:active
 {
     opacity: 1;
     filter:initial;
     cursor: default;
     background: #e78f2e;
 }

 @media (max-width: 600px) {
     .picker .btn {
         margin: 5px 0px;
         display: block;
         width: 100%;
     }
 }
</style>


<div class="button-group picker" aria-label="File Selection">
    <button type="button" class="btn btn-success {uploadActive ? 'btn-active' : ''}" disabled={uploadActive}  on:click={handleUpload} >File Upload</button>
    <button type="button" class="btn btn-success {urlActive ? 'btn-active' : ''} "  disabled={urlActive} on:click={handleURL}>URL</button>
    <button type="button" class="btn btn-success {dropboxActive ? 'btn-active' : ''}" disabled={dropboxActive}  on:click={handleDropbox}>Dropbox</button>
</div>
 
<URLUpload name={name} visible={urlActive}  bind:af={af} ></URLUpload>
<DropboxUpload name={name} visible={dropboxActive} bind:af={af}  bind:filename={filename} bind:allAFs={allAFs} ></DropboxUpload>
<FileUpload name={name} visible={uploadActive} bind:af={af} bind:filename={filename} ></FileUpload>


<div class="form-group {filename ? '' : 'hidden'}">
  <label>File</label>
	<p>{filename}</p>
</div>
